<template>
  <section>
    <template v-if="adGroupId == 0 && adId == 0">
      <choose-ad />
    </template>
    <template v-else>
      <image-ad
        v-if="imageDisplayAd"
        :ad-group-id="adGroupId"
        :ad-id="adId"
        :catalog-set-id="catalogSetId"
        :saving="saving"
        @onUpdate="updateSaving"
      />
      <html-ad
        v-if="htmlDisplayAd"
        :ad-group-id="adGroupId"
        :ad-id="adId"
        :catalog-set-id="catalogSetId"
        :saving="saving"
        @onUpdate="updateSaving"
      />
      <external-ad
        v-if="externalDisplayAd"
        :ad-group-id="adGroupId"
        :ad-id="adId"
        :catalog-set-id="catalogSetId"
        :saving="saving"
        @onUpdate="updateSaving"
      />
      <survey-ad
        v-if="surveyDisplayAd"
        :ad-group-id="adGroupId"
        :ad-id="adId"
        :catalog-set-id="catalogSetId"
        :saving="saving"
        @onUpdate="updateSaving"
      />
      <video-ad
        v-if="videoDisplayAd && !companionAd"
        :ad-group-id="adGroupId"
        :ad-id="adId"
        :catalog-set-id="catalogSetId"
        :saving="saving"
        @onUpdate="updateSaving"
      />
      <native-ad
        v-if="nativeDisplayAd"
        :ad-group-id="adGroupId"
        :ad-id="adId"
        :catalog-set-id="catalogSetId"
        :saving="saving"
        @onUpdate="updateSaving"
      />
      <video-outstream-ad
        v-if="videoOutstreamAd"
        :ad-group-id="adGroupId"
        :ad-id="adId"
        :catalog-set-id="catalogSetId"
        :saving="saving"
        @onUpdate="updateSaving"
      />
      <companion-ad
        v-if="companionAd"
        :ad-group-id="adGroupId"
        :ad-id="adId"
        :catalog-set-id="catalogSetId"
        :saving="saving"
        @onUpdate="updateSaving"
      />
      <catalog-item
        v-if="catalogItem"
        :ad-group-id="adGroupId"
        :ad-id="adId"
        :catalog-set-id="catalogSetId"
        :saving="saving"
        @onUpdate="updateSaving"
      />
      <anchor-ad
        v-if="anchorAd"
        :ad-group-id="adGroupId"
        :ad-id="adId"
        :catalog-set-id="catalogSetId"
        :saving="saving"
        @onUpdate="updateSaving"
      />
      <parallax-ad
        v-if="parallaxAd"
        :ad-group-id="adGroupId"
        :ad-id="adId"
        :catalog-set-id="catalogSetId"
        :saving="saving"
        @onUpdate="updateSaving"
      />
    </template>
    <b-modal
      id="navigation-modal"
      ref="navigation-modal"
      centered
      :title="`Are you sure you want to navigate away?`"
    >
      <p>{{ modalMessage }}</p>
      <template #modal-footer="{ cancel }">
        <b-button
          variant="outline-secondary"
          @click="cancel()"
        >
          No
        </b-button>
        <b-button
          variant="danger"
          @click="confirm"
        >
          Yes
        </b-button>
      </template>
    </b-modal>
  </section>
</template>

<script>
import CampaignsAdGroups from '@/api/client/campaignsAdgroups.service'
import CatalogItem from '@/views/client/ads-manager/create/ads/CatalogItem.vue'
import ChooseAd from './ChooseAd.vue'
import ExternalAd from './ExternalAd.vue'
import HtmlAd from './HtmlAd.vue'
import ImageAd from './ImageAd.vue'
import NativeAd from './NativeAd.vue'
import SurveyAd from './SurveyAd.vue'
import VideoAd from './VideoAd.vue'
import VideoOutstreamAd from './VideoOutstreamAd.vue'
import CompanionAd from './CompanionAd.vue'
import ParallaxAd from './ParallaxAd.vue'
import AnchorAd from './AnchorAd.vue'

const AD_TYPE_ID = {
  DISPLAY_AD: 1,
  VIDEO_AD: 2,
  NATIVE_AD: 3,
}

const AD_SUBTYPE_ID = {
  IMAGE_DISPLAY_AD: 1,
  HTML_DISPLAY_AD: 2,
  EXTERNAL_DISPLAY_AD: 3,
  BUMPER_VIDEO_AD: 4,
  SKIPPABLE_INSTREAM_VIDEO_AD: 5,
  PRODUCT_NATIVE_AD: 6,
  UNDER_VIDEO_NATIVE_AD: 7,
  SURVEY_DISPLAY_AD: 8,
  UNSKIPPABLE_INSTREAM_VIDEO_AD: 9,
  CHAT_MESSAGE_AD: 10,
  VIDEO_OUTSTREAM_AD: 11,
  COMPANION_AD: 12,
  CATALOG_ITEM: 13,
  ANCHOR_DISPLAY_AD: 15,
  PARALLAX_DISPLAY_AD: 16,
}

export default {
  components: {
    CatalogItem,
    ChooseAd,
    ExternalAd,
    HtmlAd,
    ImageAd,
    NativeAd,
    SurveyAd,
    VideoAd,
    VideoOutstreamAd,
    CompanionAd,
    ParallaxAd,
    AnchorAd,
  },
  props: {
    // eslint-disable-next-line vue/require-default-prop
    adId: Number,
    // eslint-disable-next-line vue/require-default-prop
    adGroupId: Number,
    // eslint-disable-next-line vue/require-default-prop
    catalogSetId: {
      type: String,
    },
  },
  data() {
    return {
      adType: 0,
      adSubtypeId: 0,
      loading: false,
      wrapper: {},
      modalMessage: 'Are you sure you want to navigate away? Your changes will be lost.',
      saving: false,
      savedSuccessfully: false,
    }
  },
  computed: {
    imageDisplayAd() {
      return this.adType === AD_TYPE_ID.DISPLAY_AD && this.adSubtypeId === AD_SUBTYPE_ID.IMAGE_DISPLAY_AD
    },
    htmlDisplayAd() {
      return this.adType === AD_TYPE_ID.DISPLAY_AD && this.adSubtypeId === AD_SUBTYPE_ID.HTML_DISPLAY_AD
    },
    externalDisplayAd() {
      return this.adType === AD_TYPE_ID.DISPLAY_AD && this.adSubtypeId === AD_SUBTYPE_ID.EXTERNAL_DISPLAY_AD
    },
    surveyDisplayAd() {
      return this.adType === AD_TYPE_ID.DISPLAY_AD && this.adSubtypeId === AD_SUBTYPE_ID.SURVEY_DISPLAY_AD
    },
    videoDisplayAd() {
      return this.adType === AD_TYPE_ID.VIDEO_AD
    },
    nativeDisplayAd() {
      return this.adType === AD_TYPE_ID.NATIVE_AD
    },
    videoOutstreamAd() {
      return this.adType === AD_TYPE_ID.DISPLAY_AD && this.adSubtypeId === AD_SUBTYPE_ID.VIDEO_OUTSTREAM_AD
    },
    companionAd() {
      return this.adType === AD_TYPE_ID.VIDEO_AD && this.adSubtypeId === AD_SUBTYPE_ID.COMPANION_AD
    },
    catalogItem() {
      return this.adType === AD_TYPE_ID.DISPLAY_AD && this.adSubtypeId === AD_SUBTYPE_ID.CATALOG_ITEM
    },
    anchorAd() {
      return this.adType === AD_TYPE_ID.DISPLAY_AD && this.adSubtypeId === AD_SUBTYPE_ID.ANCHOR_DISPLAY_AD
    },
    parallaxAd() {
      return this.adType === AD_TYPE_ID.DISPLAY_AD && this.adSubtypeId === AD_SUBTYPE_ID.PARALLAX_DISPLAY_AD
    },
  },
  watch: {
    $route: 'fetchData',
  },
  async mounted() {
    await this.fetchData()
  },
  methods: {
    updateSaving(value, success = false) {
      this.saving = value
      if (success) {
        this.savedSuccessfully = true
      }
    },
    adComponent() {
      if (this.adType === 1) return ExternalAd
      return ImageAd
    },
    async fetchData() {
      if (this.adGroupId !== 0 || this.adId !== 0) {
        try {
          this.wrapper = await CampaignsAdGroups.getAdGroupMeta(this.adGroupId, this.adId, this.$route.params.accountId)
        } catch (error) {
          this.error(this.$tk('ClientPortal.Form.FailedToLoadData'))
        } finally {
          this.adType = this.wrapper.adTypeId
          this.adSubtypeId = this.wrapper.adSubtypeId
        }
      }
    },
    showConfirmationModal() {
      this.$refs['navigation-modal'].show()
      return new Promise(resolve => {
        this.$once('confirmed', () => {
          resolve()
        })
      })
    },
    confirm() {
      this.$emit('confirmed')
    },
  },
  beforeRouteLeave(to, from, next) {
    const handlers = this.adType
    if (handlers && !this.saving && !this.savedSuccessfully) {
      this.showConfirmationModal().then(() => {
        next()
      }).catch(() => {
        next(false)
      })
    } else {
      next()
    }
  },
}
</script>
